import React from 'react';

interface CompleteStepProps {
  tenant: any;
  onFinish: () => void;
  onViewTenant: () => void;
}

const CompleteStep: React.FC<CompleteStepProps> = ({ tenant, onFinish, onViewTenant }) => {
  return (
    <div className="card shadow">
      <div className="card-body">
        <div className="text-center py-5">
          <div className="mb-4">
            <i className="fas fa-check-circle text-success" style={{ fontSize: '4rem' }}></i>
          </div>
          
          <h3 className="mb-3">MPX Tenant Created Successfully!</h3>
          
          <p className="text-muted mb-4">
            The MPX tenant has been successfully added to your system.
          </p>

          <div className="card bg-light mb-4 mx-auto" style={{ maxWidth: '600px' }}>
            <div className="card-body text-left">
              <h5 className="font-weight-bold mb-3 text-center">{tenant?.name}</h5>
              
              <div className="mb-3">
                <strong>MPX Control Plane DID:</strong>
                <div className="mt-1">
                  <code style={{ fontSize: '0.85rem', wordBreak: 'break-all' }}>{tenant?.did}</code>
                </div>
              </div>

              <div className="mb-3">
                <strong>API Endpoint:</strong>
                <div className="mt-1">
                  <code style={{ fontSize: '0.85rem', wordBreak: 'break-all' }}>{tenant?.api_endpoint}</code>
                </div>
              </div>

              {tenant?.description && (
                <div className="mb-3">
                  <strong>Description:</strong>
                  <div className="mt-1">{tenant.description}</div>
                </div>
              )}

              <div className="mb-3">
                <strong>Status:</strong>
                <div className="mt-1">
                  <span className="badge badge-success">ACTIVE</span>
                </div>
              </div>

              <div className="mb-0">
                <strong>Created:</strong>
                <div className="mt-1">
                  {tenant?.created_at ? new Date(tenant.created_at).toLocaleString() : 'Just now'}
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-center" style={{ gap: '1rem' }}>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onFinish}
            >
              <i className="fas fa-list mr-2"></i> View All Integrations
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={onViewTenant}
            >
              <i className="fas fa-eye mr-2"></i> View Tenant
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompleteStep;
